import { useSearchParams } from "react-router-dom";
import { useCurrentUser } from "~/features/auth/hooks/use-current-user";
import { PageSpinner } from "~/shared/ui/PageSpinner";
import { AdminBranchView } from "./AdminBranchView";
import { CustomerBranchView } from "./CustomerBranchView";

export function BranchManagementPage() {
  const { data: currentUser, isPending } = useCurrentUser();
  const [searchParams] = useSearchParams();

  if (isPending || !currentUser) {
    return <PageSpinner />;
  }

  // ?view=customer 로 고객사 뷰 강제 확인 가능 (개발용)
  const forceView = searchParams.get("view");
  const showAdmin =
    forceView === "customer" ? false : forceView === "admin" ? true : currentUser.isStaff;

  return showAdmin ? <AdminBranchView /> : <CustomerBranchView />;
}
